import { TagPicker } from "@fluentui/react";
import { t } from "i18next";
import { getIn } from "formik";

const FormikTagPicker = ({ field, form, ...props }) => {
  const handleChange = (items) => {
    const values = items
      .map((item) => item.name)
      .filter((val) => val?.trim() !== ""); // prevent empty values
    form.setFieldValue(field.name, values);
  };

  const errorMessage = getIn(props.allErrors, field.name);

  return (
    <>
      <TagPicker
        onResolveSuggestions={(filter, selectedItems) =>
          filter ? [{ key: filter, name: filter }] : []
        }
        getTextFromItem={(item) => item.name}
        onChange={handleChange}
        selectedItems={
          Array.isArray(field.value)
            ? field.value
                .filter((val) => val?.trim() !== "") // filter out empty strings
                .map((val) => ({ key: val, name: val }))
            : []
        }
        inputProps={{
          placeholder: t("hanging-protocol.value"),
        }}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />

      {errorMessage && (
        <span id={`${field.name}-errors`}>
          <div role="alert">
            <p className="error-message">
              <span>{errorMessage}</span>
            </p>
          </div>
        </span>
      )}
    </>
  );
};

export default FormikTagPicker;
